import { Location } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { CustomAssessmentsService } from '../../services/custom-assessments.service';
import { CustomAssessment } from '../../services/model';

type AssesmentViewModel = {
  shortName: string;
  fullName: string;
  path?: string;
  customId?: number;
};

@Component({
  selector: 'app-select-assessment',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatTableModule,
    MatIconModule,
    RouterModule,
    NavigationComponent,
  ],
  templateUrl: './select-assessment.component.html',
  styleUrl: './select-assessment.component.scss',
})
export class SelectAssessmentComponent {
  location: Location = inject(Location);
  customAssessmentsService = inject(CustomAssessmentsService);
  customAssessmentList: Signal<CustomAssessment[]> = this.customAssessmentsService.customAssessmentList;
  customAssessmentListVisible: Signal<CustomAssessment[]> = computed(() => {
    return this.customAssessmentsService.customAssessmentList().filter(item => item.visible);
  });
  assessmentListMixed: Signal<AssesmentViewModel[]> = computed(() => {
    const mixed: AssesmentViewModel[] = [
      { shortName: 'ARAT', fullName: 'Action Research Arm Test', path: 'arat' },
      { shortName: 'BBT', fullName: 'Box and Block Test', path: 'bbt' },
      { shortName: 'BBS', fullName: 'Berg Balance Scale', path: 'bbs' },
      { shortName: 'FGA', fullName: 'Functional Gait Assessment', path: 'fga' },
      { shortName: 'NHPT', fullName: 'Nine Hole Peg Test', path: 'nhpt' },
      { shortName: 'TUG', fullName: 'Timed Up and Go', path: 'tug' },
    ];
    this.customAssessmentListVisible().forEach(item =>
      mixed.push({ shortName: item.shortName, fullName: item.fullName ?? '', customId: item.id })
    );
    return mixed.sort((a, b) => a.shortName.localeCompare(b.shortName));
  });
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);

  constructor() {
    this.customAssessmentsService.getCustomAssessments();
  }

  editAssesmentList() {
    console.log('editAssesmentList');
  }

  onCustomAssessment(customId: number): void {
    this.router.navigate(['../custom'], { relativeTo: this.route, queryParams: { id: customId } });
  }

  onStandardAssessment(path: string) {
    this.router.navigate(['../' + path], { relativeTo: this.route });
  }
}
